import { Fragment, useState, useSyncExternalStore, type ReactNode } from "react";
import { StoreBindingAttemptProvider } from "@/shared/storeBindingAttempt";
import { getPrivateSessionState, subscribePrivateSession } from "@/lib/api/private-session";

/**
 * An identity transition discards forms, toasts, print and notification observers together.
 *
 * The identity key moves only when an identity that was KNOWN is replaced (another
 * store, another person, or signed out). Learning the identity for the first time is
 * not a transition: at boot it starts unknown and the first `/me` fills it in, and
 * keying on that remounted the whole app mid-boot — the splash came up, went blank,
 * came up again, and every query (the session first) was asked twice.
 */
export function PrivateIdentityTree({ children }: { children: ReactNode }) {
  const session = useSyncExternalStore(subscribePrivateSession, getPrivateSessionState);
  const identity =
    session.actorId || session.storeSlug ? `${session.actorId ?? ""}:${session.storeSlug ?? ""}` : null;
  const [seen, setSeen] = useState({ identity, epoch: 0 });
  if (identity !== seen.identity) {
    setSeen({ identity, epoch: seen.identity === null ? seen.epoch : seen.epoch + 1 });
  }
  return <StoreBindingAttemptProvider key={seen.epoch}><Fragment key={session.generation}>{children}</Fragment></StoreBindingAttemptProvider>;
}
